/* eslint-disable no-throw-literal */
import normalizeById from 'app/utils/NormalizeById';
import ApiService from 'app/services/ApiService';

export const COURSEAVAILABLE_ADD = 'COURSEAVAILABLE_ADD';
export const COURSEAVAILABLE_BEGIN = 'COURSEAVAILABLE_BEGIN';
export const COURSEAVAILABLE_FAILURE = 'COURSEAVAILABLE_FAILURE';
export const COURSEAVAILABLE_CLEAR = 'COURSEAVAILABLE_CLEAR';
export const SET_COURSEAVAILABLE_USED = 'SET_COURSEAVAILABLE_USED';
export const REMOVE_COURSEAVAILABLE_USED = 'REMOVE_COURSEAVAILABLE_USED';

export function fetchCourseAvailable(data) {
	return async dispatch => {
        dispatch(courseAvailableBegin());
        await ApiService.getCoursesAvailable(data)
			.then(
				result => {
                    dispatch(courseAvailableAdd(result.Data));
				},
				error => {
                    dispatch(courseAvailableError());
					throw ({error: error, message: 'An error ocurred'});
				}
			)
	};
}


export const courseAvailableBegin = () => ({
    type: COURSEAVAILABLE_BEGIN,
});

export const courseAvailableAdd = data => ({
    type: COURSEAVAILABLE_ADD,
	payload: data
})

export const courseAvailableError = () => ({
    type: COURSEAVAILABLE_FAILURE,
})

export const courseAvailableClear = () =>({
    type: COURSEAVAILABLE_CLEAR,
})

export const setCourseUsed = (id) => ({
	type: SET_COURSEAVAILABLE_USED,
	payload: id
});

export const removeCourseUsed = (id) => ({
	type: REMOVE_COURSEAVAILABLE_USED,
	payload: id
});